import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    staticClass: "sa_note",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', [_c('strong', [_vm._v("04 INV主檔")]), _vm._v(" —— 每台 INV 的品牌、型號、容量。INV 同儕分群靠這張。 ")]), _c('ul', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', [_c('strong', [_vm._v("同儕分群依據")]), _vm._v("：品牌 + 型號 + "), _c('strong', [_vm._v("實際串接容量")]), _vm._v("，三個全同才算同儕。 實際串接容量不是銘牌容量 —— 有高接／低接時兩者不同，以實際為準。同儕群組代號留空就由引擎自己分。 ")]), _c('li', [_c('strong', [_vm._v("INV 索引必須與遙測陣列一致")]), _vm._v("（第一台是 0），填錯會整台對到別台的資料。 ")]), _c('li', [_vm._v(" 按「由 02／05／06 產生」：INV 編號與上游節點跟 02 要，串列總數與 MPPT 總數算 05， 實際串接容量加總 06。所以"), _c('strong', [_vm._v("先建 05、06 再來這頁")]), _vm._v("；之後 05／06 改過，這三欄要重產或手動改，不會自己跟著變。 ")])])]), _c('div', {
    staticClass: "px-2 pt-2"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-info",
      "disabled": !_vm.siteCode,
      "title": "INV 清單與串數、容量從主檔 02／05／06 彙總，品牌型號填一次整批寫入"
    },
    on: {
      "click": function click($event) {
        _vm.open = true;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-project-diagram"
  }), _vm._v(" 由 02／05／06 產生 ")])], 1), _c('MasterDataTable', _vm._g({
    ref: "table",
    attrs: {
      "table": "inverter_master",
      "def": _vm.def,
      "site-code": _vm.siteCode
    }
  }, _vm.$listeners)), _c('b-modal', {
    attrs: {
      "title": "由 02／05／06 產生 INV主檔",
      "size": "xl",
      "scrollable": "",
      "ok-title": "寫入",
      "cancel-title": "取消",
      "ok-disabled": _vm.saving || !_vm.rows.length
    },
    on: {
      "show": _vm.onShow,
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.open,
      callback: function callback($$v) {
        _vm.open = $$v;
      },
      expression: "open"
    }
  }, [_vm.loadError ? _c('b-alert', {
    staticClass: "py-2 im_hint",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.loadError))]) : !_vm.loading && !_vm.rows.length ? _c('b-alert', {
    staticClass: "py-2 im_hint",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm.siteCode) + " 的 02 沒有 INV 節點、05 也是空的，產不出 INV 清單。先去建 05。 ")]) : _c('div', {
    staticClass: "im_hint mb-2"
  }, [_vm._v(" 共 "), _c('strong', [_vm._v(_vm._s(_vm.rows.length))]), _vm._v(" 台。 "), _vm.noDesign ? [_vm._v("06 還沒建，"), _c('strong', [_vm._v("實際串接容量會留空")]), _vm._v("。")] : _vm._e(), _vm.existing ? [_vm._v("已經有 " + _vm._s(_vm.existing) + " 列，寫入時"), _c('strong', [_vm._v("已存在的 INV 會略過、不覆蓋")]), _vm._v("。")] : _vm._e()], 2), _vm._l(_vm.specColumns, function (c) {
    return _c('b-form-group', {
      key: c.name,
      staticClass: "mb-2",
      attrs: {
        "label": c.label + (c.required ? ' *' : ''),
        "description": c.name === 'parent_node_id' ? '留空 = 照 02 各 INV 節點的上游；填了就整批套這個值' : c.hint,
        "label-cols-md": "3",
        "label-size": "sm"
      }
    }, [_c('b-form-input', {
      attrs: {
        "size": "sm",
        "type": c.type === 'text' || c.type === 'date' ? c.type : 'number',
        "step": "any",
        "maxlength": c.maxLength
      },
      model: {
        value: _vm.spec[c.name],
        callback: function callback($$v) {
          _vm.$set(_vm.spec, c.name, $$v);
        },
        expression: "spec[c.name]"
      }
    })], 1);
  }), _vm.rows.length ? _c('b-table', {
    staticClass: "im_table",
    attrs: {
      "items": _vm.rows,
      "fields": _vm.previewFields,
      "small": "",
      "bordered": ""
    }
  }) : _vm._e(), _vm.error ? _c('b-alert', {
    staticClass: "py-2 mb-0 mt-2",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };